import React from "react";

const Ternary_Operator = () => {
  return (
    <div>
      <h1>Ternary_Operator Component</h1>
      <p>Content for Ternary_Operator goes here...</p>
    </div>
  );
};

export default Ternary_Operator;
